import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import { PMTitleCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";
import { getPluralOfProjectName } from "../../../utils/get-plural-of-project-name";
import { getOverviewCardCopy } from "../get-card-copy";

export function addTitleCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
): void {
  const { getCardCopy } = getOverviewCardCopy(app);

  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      labels: ["title"],
      title: "",
      description: "",
    },
  });

  titleComponent.mapLayoutProps(({ language }) => ({
    componentId: "titleComponent",
    labels: ["title"],
    title: getCardCopy(language, "overviewTitle").title || "Title",
    description: getCardCopy(language, "overviewTitle").description,
  }));

  titleComponent.mapState(({ overview, settings, language }) => {
    return {
      title: `${getLocalizedMessage(language, "overview", {
        overviewItem: getPluralOfProjectName(
          settings?.configuration?.projectName,
          language
        ),
      })}${
        settings?.configuration?.programName
          ? ` - ${settings?.configuration?.programName}`
          : ""
      }`,
      badgeConfigs: overview?._calculated?.lastReportingEndDate
        ? [
            {
              label: `${
                getLocalizedMessage(language, "AsOf") || "As of"
              }: ${formatDate(overview?._calculated?.lastReportingEndDate, language)}`,
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.primary.main,
            },
          ]
        : [],
    };
  });
}
